/*** IMPORTS FROM imports-loader ***/
(function() {
var define = false;

'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _createClass = require('babel-runtime/helpers/create-class')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _Promise = require('babel-runtime/core-js/promise')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _srcSettings = require('../../../src/settings');

var _srcSettings2 = _interopRequireDefault(_srcSettings);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactDisqusThread = require('react-disqus-thread');

var _reactDisqusThread2 = _interopRequireDefault(_reactDisqusThread);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactLoader = require('react-loader');

var _reactLoader2 = _interopRequireDefault(_reactLoader);

var _reactRouter = require('react-router');

var _helpersConnectData = require('helpers/connectData');

var _helpersConnectData2 = _interopRequireDefault(_helpersConnectData);

var _reactRedux = require('react-redux');

var _reduxModulesArticle = require('redux/modules/article');

var _reduxModulesAdGroup = require('redux/modules/adGroup');

var _reduxModulesMostPopular = require('redux/modules/mostPopular');

var _reduxModulesMoreArticles = require('redux/modules/moreArticles');

var _utils = require('utils');

var _components = require('components');

var _lodashFind = require('lodash/find');

var _lodashFind2 = _interopRequireDefault(_lodashFind);

var _lodashIsEmpty = require('lodash/isEmpty');

var _lodashIsEmpty2 = _interopRequireDefault(_lodashIsEmpty);

var _lodashFilter = require('lodash/filter');

var _lodashFilter2 = _interopRequireDefault(_lodashFilter);

var _lodashUnescape = require('lodash/unescape');

var _lodashUnescape2 = _interopRequireDefault(_lodashUnescape);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

if (__CLIENT__) {
	require('../../../static/js/jquery.sticky-kit');
}

function fetchDataDeferred(getState, dispatch) {
	var promises = [];
	var state = getState();

	if (!_reduxModulesAdGroup.isLoaded(state)) {
		promises.push(dispatch(_reduxModulesAdGroup.load(119080)));
	}

	if (!_reduxModulesMoreArticles.isLoaded(state)) {
		promises.push(dispatch(_reduxModulesMoreArticles.load(state.router.params.name, 2)));
	}

	if (!_reduxModulesArticle.isLoaded(state) && state.router.params.name) {
		promises.push(dispatch(_reduxModulesArticle.load(state.router.params.name)));
	}

	return _Promise.all(promises);
}

var Articles = (function (_Component) {
	_inherits(Articles, _Component);

	function Articles() {
		_classCallCheck(this, _Articles);

		_Component.apply(this, arguments);

		this.state = {
			isPreview: false,
			mostPopularIsStuck: false,
			mostPopularIsStuckToBottom: false,
			showSidebar: false
		};
	}

	Articles.prototype.componentDidMount = function componentDidMount() {
		var _this = this;

		// Load article
		var dispatch = this.context.store.dispatch;
		var state = this.context.store.getState();
		if (!_reduxModulesArticle.isLoaded(state) && state.router.params.postID) {
			var authData = JSON.parse(localStorage.getItem('authData'));
			if (authData && authData.token) {
				dispatch(_reduxModulesArticle.loadArticlePreview(state.router.params.postID, authData ? authData.token : 0));
			}
		}

		/**
   * Sticky Elements
   */
		var waitForEl = setInterval(function () {
			var mostPopular = _reactDom2['default'].findDOMNode(_this.refs.mostPopular);

			if (mostPopular) {
				clearInterval(waitForEl);
				_jquery2['default'](mostPopular).stick_in_parent({
					offset_top: -264
				});
			}
		}, 300);
	};

	Articles.fetchData = function fetchData(getState, dispatch) {
		var promises = [];
		var state = getState();

		if (!_reduxModulesMostPopular.isLoaded(state)) {
			promises.push(dispatch(_reduxModulesMostPopular.load()));
		}

		return _Promise.all(promises);
	};

	Articles.prototype.render = function render() {
		var _classNames,
		    _classNames2,
		    _classNames3,
		    _classNames4,
		    _this2 = this;

		var styles = require('./Article.css');

		// Show loading spinner while article is fetched
		if (this.props.loading || this.props.loading === undefined) {
			return _react2['default'].createElement(
				'main',
				{ className: styles.Base },
				_react2['default'].createElement(_reactLoader2['default'], {
					className: 'spinner',
					color: 'rgb(255, 78, 61)',
					corners: 0,
					direction: 1,
					hwaccel: true,
					left: '50%',
					length: 6,
					lines: 13,
					opacity: 0.1,
					radius: 7,
					rotate: 13,
					scale: 1.00,
					shadow: false,
					speed: 2,
					top: '50%',
					trail: 60,
					width: 2,
					zIndex: 2e9 })
			);
		}

		var _props = this.props;
		var article = _props.article;
		var ads = _props.ads;
		var isSmallViewport = _props.isSmallViewport;
		var isMediumViewport = _props.isMediumViewport;
		var location = _props.location;

		if (__CLIENT__ && article && article.id) {
			document.body.className = 'article-' + article.id;
		}

		var adsBottom = _lodashFind2['default'](ads, function (ad) {
			return ad.position === 'bottom';
		});
		var adsBottomSquare = undefined;
		var adsBottomLeaderboard = undefined;
		if (!_lodashIsEmpty2['default'](adsBottom)) {
			// Get all 300×250 ads
			adsBottomSquare = _lodashFilter2['default'](adsBottom.ads, function (ad) {
				return ad.title.indexOf('300x250') > -1;
			});
			// Get all 728x90 ads
			adsBottomLeaderboard = _lodashFilter2['default'](adsBottom.ads, function (ad) {
				return ad.title.indexOf('728x90') > -1;
			});
		}

		var articleClasses = _classnames2['default']((_classNames = {}, _classNames[styles.Article] = true, _classNames[styles['Article--withImage']] = article.images && article.images['bbrew-feature-small'], _classNames));

		var mostPopularWrapperClasses = _classnames2['default']((_classNames2 = {}, _classNames2[styles.MostPopularWrapper] = true, _classNames2['MostPopularWrapper--isStuck'] = this.state.mostPopularIsStuck, _classNames2['MostPopularWrapper--isStuckToBottom'] = this.state.mostPopularIsStuckToBottom, _classNames2));

		var contentWrapperClasses = _classnames2['default']((_classNames3 = {}, _classNames3[styles.ContentRegion] = true, _classNames3.CMSContent = true, _classNames3));

		var contentClasses = _classnames2['default']((_classNames4 = {}, _classNames4[styles.Content] = true, _classNames4.CMSContent = true, _classNames4['CMSContent--withEndcap'] = true, _classNames4));

		var theImages = article.images;
		var featureImageWidth = theImages['bbrew-feature'][1];
		var featureImageHeight = theImages['bbrew-feature'][2];
		var featureImage = undefined;

		// Check for optimal feature image size
		if (_utils.checkAspectRatio(featureImageWidth, featureImageHeight)) {
			featureImage = article.images['bbrew-feature'][0];
		} else {
			featureImage = article.images['bbrew-feature-small'][0];
		}

		// Terrible fix for DISQUS comment count issue
		var waitForLoadToComplete = setInterval(function () {
			if (!_this2.props.loading && __CLIENT__) {
				clearInterval(waitForLoadToComplete);
				(function () {
					window.DISQUSWIDGETS = undefined;
					var s = document.createElement('script');
					s.id = 'dsq-count-scr';
					s.async = true;
					s.type = 'text/javascript';
					s.src = 'https://baltimorebrew.disqus.com/count.js';
					(document.getElementsByTagName('HEAD')[0] || document.getElementsByTagName('BODY')[0]).appendChild(s);
				})();
			}
		}, 500);

		return _react2['default'].createElement(
			'main',
			{ className: styles.Base },
			_react2['default'].createElement(_reactHelmet2['default'], {
				title: '' + _lodashUnescape2['default'](article.title),
				meta: [{ property: 'og:type', content: 'article' }, { property: 'og:image', content: 'https:' + _srcSettings2['default'].cdn + featureImage }, { property: 'og:title', content: _lodashUnescape2['default'](article.title) + ' | Baltimore Brew' }, { property: 'og:description', content: '' + _lodashUnescape2['default'](article.excerpt) }, { property: 'og:image:width', content: '1280' }, { property: 'og:image:height', content: '720' }]
			}),
			_react2['default'].createElement(
				'article',
				{ className: articleClasses, ref: 'theArticle' },
				article.images && featureImage && _react2['default'].createElement(
					'figure',
					{ className: styles['Figure--featured'] },
					_react2['default'].createElement('img', { className: styles.FigureImage, src: '' + _srcSettings2['default'].cdn + featureImage })
				),
				_react2['default'].createElement(
					'header',
					{ className: styles.ArticleHeader },
					article.specialSeries && article.specialSeries.name && _react2['default'].createElement(_components.HeaderTab, {
						className: styles.HeaderTab,
						icon: 'pot',
						title: article.specialSeries.name,
						url: '/special-series/' + article.specialSeries.slug
					}),
					_react2['default'].createElement(_components.MetaBar, {
						articleID: article.id,
						author: article.author.guest ? article.author.guest[0] : article.author.name,
						authorURI: article.author.guest ? false : article.author.slug,
						categories: article.categories,
						commentCount: article.commentCount,
						postDate: article.date,
						withPostTime: true }),
					_react2['default'].createElement(
						'h1',
						{ className: styles.Title },
						article.title
					),
					article.subTitle && _react2['default'].createElement(
						'p',
						{ className: styles.IntroText },
						article.subTitle
					),
					article.images && article.images['bbrew-feature-small'] && article.imageMeta && article.imageMeta.description && _react2['default'].createElement(
						'p',
						{ className: styles.ImageCaption },
						'Above: ',
						article.imageMeta.description
					)
				),
				_react2['default'].createElement(
					'div',
					{ className: styles.ContentWrapper, ref: 'contentWrapper' },
					_react2['default'].createElement(_components.ShareTools, {
						className: styles.ShareTools,
						title: article.title,
						url: 'https://baltimorebrew.com' + location.pathname
					}),
					_react2['default'].createElement(
						'div',
						{ className: contentWrapperClasses },
						_react2['default'].createElement('div', { className: contentClasses, dangerouslySetInnerHTML: { __html: article.content } })
					),
					!isSmallViewport && !isMediumViewport && _react2['default'].createElement(
						'div',
						{ className: mostPopularWrapperClasses, ref: 'mostPopular' },
						_react2['default'].createElement(_components.MostPopular, { className: styles.MostPopular, withNumbers: false })
					)
				),
				_react2['default'].createElement(
					'footer',
					{ className: styles.Footer },
					_react2['default'].createElement(
						'div',
						{ className: styles.CommentsSocial },
						_react2['default'].createElement(
							'a',
							{ href: '#comments', className: styles.CommentsAnchor },
							_react2['default'].createElement(
								'span',
								{ className: styles.CommentsTab },
								'View Comments'
							),
							_react2['default'].createElement(_components.CommentCount, {
								articleID: article.id,
								color: 'red',
								count: article.commentCount,
								className: styles.CommentsCount
							})
						),
						!isSmallViewport ? _react2['default'].createElement(_components.ShareTools, {
							className: styles.FooterShareTools,
							layout: 'horizontal',
							title: article.title,
							url: 'https://baltimorebrew.com' + location.pathname
						}) : null
					),
					adsBottomSquare && adsBottomSquare.length > 0 && isSmallViewport && _react2['default'].createElement(
						'section',
						{ className: styles.AdSpace },
						_react2['default'].createElement(
							_components.Ad,
							{
								className: styles.Ad,
								href: adsBottomSquare[0].url,
								ratio: '4x3',
								target: '_blank'
							},
							_react2['default'].createElement('img', { className: styles.Image, src: '' + _srcSettings2['default'].cdn + adsBottomSquare[0].image.src, alt: adsBottomSquare[0].image.title })
						)
					),
					!isSmallViewport && isMediumViewport && _react2['default'].createElement(
						'div',
						{ className: mostPopularWrapperClasses, ref: 'mostPopular' },
						_react2['default'].createElement(_components.MostPopular, { className: styles.MostPopular, withNumbers: false })
					),
					_react2['default'].createElement(_components.MoreArticles, {
						className: styles.MoreArticles,
						isSpecialSeries: article.specialSeries ? true : false }),
					adsBottomLeaderboard && adsBottomLeaderboard.length > 0 && !isSmallViewport && _react2['default'].createElement(
						'div',
						{ className: styles.AdSpace },
						_react2['default'].createElement(
							_components.Ad,
							{
								className: styles.Ad,
								href: adsBottomLeaderboard[0].url,
								ratio: '8x1',
								target: '_blank'
							},
							_react2['default'].createElement('img', { className: styles.Image, src: '' + _srcSettings2['default'].cdn + adsBottomLeaderboard[0].image.src, alt: adsBottomLeaderboard[0].image.title })
						)
					),
					isSmallViewport && !isMediumViewport && _react2['default'].createElement(
						'div',
						{ className: mostPopularWrapperClasses, ref: 'mostPopular' },
						_react2['default'].createElement(_components.MostPopular, { className: styles.MostPopular, withNumbers: false })
					),
					this.props.params.postID === undefined && _react2['default'].createElement(
						'section',
						{ className: styles.Comments, id: 'comments' },
						_react2['default'].createElement(
							_reactRouter.Link,
							{ className: styles.CommentNotice, to: '/page/comment-moderation-policy/' },
							'Please read our moderation policy before leaving a comment.'
						),
						_react2['default'].createElement(_reactDisqusThread2['default'], {
							shortname: 'baltimorebrew',
							identifier: article.id > 122550 ? 'baltimore-brew-' + article.id : article.id + ' https://www.baltimorebrew.com/?p=' + article.id,
							title: article.title,
							url: 'https://www.baltimorebrew.com' + article.url })
					)
				)
			)
		);
	};

	_createClass(Articles, null, [{
		key: 'propTypes',
		value: {
			ads: _react.PropTypes.array,
			article: _react.PropTypes.object,
			articleError: _react.PropTypes.object,
			isSmallViewport: _react.PropTypes.bool,
			isMediumViewport: _react.PropTypes.bool,
			loading: _react.PropTypes.bool,
			moreArticles: _react.PropTypes.array,
			moreArticlesError: _react.PropTypes.object,
			moreArticlesLoading: _react.PropTypes.bool,
			location: _react.PropTypes.object,
			params: _react.PropTypes.object
		},
		enumerable: true
	}, {
		key: 'contextTypes',
		value: {
			store: _react.PropTypes.object.isRequired
		},
		enumerable: true
	}]);

	var _Articles = Articles;
	Articles = _reactRedux.connect(function (state) {
		return {
			ads: state.adGroup.data,
			article: state.article.data,
			articleError: state.article.error,
			isSmallViewport: state.responsive.isSmallViewport,
			isMediumViewport: state.responsive.isMediumViewport,
			loading: state.article.loading,
			moreArticles: state.moreArticles.data,
			moreArticlesError: state.moreArticles.error,
			moreArticlesLoading: state.moreArticles.loading
		};
	})(Articles) || Articles;
	Articles = _helpersConnectData2['default'](null, fetchDataDeferred)(Articles) || Articles;
	return Articles;
})(_react.Component);

exports['default'] = Articles;
module.exports = exports['default'];
}.call(window));


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/Article/Article.js
 ** module id = 699
 ** module chunks = 0
 **/